import React, { useState } from 'react';
import useItems from './useItems';
import Calculator from './Calculator';
import EditItems from './EditItems';
import styles from './App.module.css';

const TABS = [
  { id: 'calc', label: 'Calculadora' },
  { id: 'edit', label: 'Valores base' },
];

export default function App() {
  const [activeTab, setActiveTab] = useState('calc');
  const { items, updateItem, resetItems, getPrice } = useItems();

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <header className={styles.header}>
          <div className={styles.brand}>
            <img className={styles.logo} src="/md.png" alt="Yalug" />
            <span className={styles.badge}>Lavanderia</span>
          </div>
          <div className={styles.headerText}>
            <h1 className={styles.title}>Calculadora de custos</h1>
            <p className={styles.subtitle}>Locação e lavanderia para enxoval de estadias</p>
          </div>
        </header>

        <nav className={styles.tabs} aria-label="Secoes da calculadora">
          {TABS.map(tab => (
            <button
              key={tab.id}
              className={`${styles.tab} ${activeTab === tab.id ? styles.active : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </nav>

        <main className={styles.content}>
          {activeTab === 'calc' && (
            <Calculator getPrice={getPrice} />
          )}
          {activeTab === 'edit' && (
            <EditItems
              items={items}
              onUpdate={updateItem}
              onReset={resetItems}
            />
          )}
        </main>
      </div>
    </div>
  );
}
